/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 用户登录
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  orderDetailSeatDto: order.OrderDetailSeatDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/register-ticket`,
    data: orderDetailSeatDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
